import { LitLab } from 'common-types'
import BigBooksLitLab from 'components/arc-core/BigBooksLitLab'
import Framework from 'components/arc-core/Framework'
import HookBooks from 'components/arc-core/HookBooks'
import MagicTreeHouse from 'components/arc-core/MagicTreeHouse'
import NarrativeTextSet from 'components/arc-core/NarrativeTextSet'
import PacingGuide from 'components/arc-core/PacingGuide'
import PairedCoreTexts from 'components/arc-core/PairedCoreTexts'
import PhonemicAwareness from 'components/arc-core/PhonemicAwareness'
import PoetryTextSet from 'components/arc-core/PoetryTextSet'
import ReadAloudCollectionFour from 'components/arc-core/ReadAloudCollectionFour'
import ReadAloudCollectionOne from 'components/arc-core/ReadAloudCollectionOne'
import ReadingSuccess from 'components/arc-core/ReadingSuccess'
import WholeYear from 'components/arc-core/WholeYear'
import WritersNotebook25 from 'components/arc-core/WritersNotebook25'
import WritersNotebookK1 from 'components/arc-core/WritersNotebookK1'
import { Col, Row } from 'components/grid'
import React from 'react'

interface Props {
	standard: 'CCSS' | 'TEKS'
	language: 'english' | 'spanish'
	litLab: LitLab
	grade: number
	gradeRange: 'k-2' | '3-5' | '6-8' | 'hs'
	hookBooks?: LitLab['hookBookLibrary']
	isCompatible?: boolean
}

export default function LitLabSection({ standard, language, litLab, grade, gradeRange, hookBooks, isCompatible }: Props) {
	return (
		<div>
			<Row center>
				<Col width="w-1/2 md:w-1/3" className="material-column">
					<Framework
						image={standard === 'TEKS' ? litLab?.frameworkCoverTeks?.gatsbyImageData : litLab?.frameworkCover?.gatsbyImageData}
						fullFramework={standard === 'TEKS' ? litLab?.fullFrameworkTeks?.file?.url : litLab?.fullFramework?.file?.url}
						updatedAt={standard === 'TEKS' ? litLab?.fullFrameworkTeks?.updatedAt : litLab?.fullFramework?.updatedAt}
					/>
				</Col>
				{litLab.pacingGuide && (
					<Col width="w-1/2 md:w-1/3" className="material-column">
						<PacingGuide images={standard === 'TEKS' ? litLab.pacingGuideTeks : litLab.pacingGuide} />
					</Col>
				)}
				{/* {litLab.grade === 'Grade K' && (
					<Col width="w-1/2 md:w-1/3" className="material-column">
						<ScopeSequence language={language} standard={standard} />
					</Col>
				)} */}
				{litLab.notebooks ? (
					litLab.grade === 'Grade K' || litLab.grade === 'Grade 1' ? (
						<Col width="w-1/2 md:w-1/3" className="material-column">
							<WritersNotebookK1
								writers={litLab.writersNotebook?.file.url}
								wordStudy={litLab.wordStudyNotebook?.file.url}
								grade={grade}
								image={litLab.notebooks[0].gatsbyImageData}
								updatedAt={[litLab.writersNotebook?.updatedAt, litLab.wordStudyNotebook?.updatedAt]}
							/>
						</Col>
					) : (
						<Col width="w-1/2 md:w-1/3" className="material-column">
							<WritersNotebook25
								updatedAt={litLab.writersNotebook?.updatedAt}
								notebook={litLab.writersNotebook?.file.url}
								language={language}
								grade={grade}
								image={litLab.notebooks[0].gatsbyImageData}
							/>
						</Col>
					)
				) : null}
				{litLab.grade === 'Grade K' && (
					<Col width="w-1/2 md:w-1/3" className="material-column">
						<BigBooksLitLab language={language} />
					</Col>
				)}
				{language === 'english' && litLab.grade === 'Grade K' && !isCompatible && (
					<Col width="w-1/2 md:w-1/3" className="material-column">
						<PhonemicAwareness />
					</Col>
				)}
				{language === 'english' && litLab.grade === 'Grade 1' && !isCompatible && (
					<Col width="w-1/2 md:w-1/3" className="material-column">
						<ReadingSuccess />
					</Col>
				)}
				{litLab.grade === 'Grade 2' && (
					<Col width="w-full md:w-1/3" className="material-column">
						<ReadAloudCollectionOne baskets={litLab.readAloudCollection} />
					</Col>
				)}
				{litLab.narrativeMiniTextSet && (
					<Col width="w-1/2 md:w-1/3" className="material-column">
						<NarrativeTextSet language={language} />
					</Col>
				)}
				{litLab.poetryMiniTextSet && (
					<Col width="w-full md:w-1/3" className="material-column">
						<PoetryTextSet language={language} />
					</Col>
				)}
				{litLab.magicTreeHouse && (
					<Col width="w-full sm:w-1/2" className="material-column">
						<MagicTreeHouse language={language} />
					</Col>
				)}
				{litLab.fictionHookBook && litLab.relatedInformationalText && (
					<Col width="w-full sm:w-1/2" className="material-column">
						<PairedCoreTexts hookBook={litLab.fictionHookBook.gatsbyImageData} infoText={litLab.relatedInformationalText.gatsbyImageData} />
					</Col>
				)}
				{gradeRange !== 'hs' && litLab.hookBookLibrary && (
					<Col width="w-full sm:w-1/2" className="material-column">
						<HookBooks baskets={litLab.hookBookLibrary} />
					</Col>
				)}
			</Row>
			{litLab.grade !== 'Grade 2' && litLab.readAloudCollection && (
				<Row className="mb-6 justify-center px-6">
					<Col width="w-full md:w-3/4 material-column">
						<ReadAloudCollectionFour baskets={litLab.readAloudCollection} />
					</Col>
				</Row>
			)}
			<Row className="md:pl-14 md:pr-4">
				<WholeYear
					isCompatible={isCompatible}
					hookBooks={hookBooks}
					data={litLab}
					language={language}
					standard={standard}
					hundredBookChallenge={litLab.hundredBookChallenge}
					fstk={litLab.fstk?.gatsbyImageData}
					grade={gradeRange}
					cape={grade === 0}
				/>
			</Row>
		</div>
	)
}
